module.exports = __webpack_public_path__ + "static/media/muu.d8ea119a.png";